import angular from 'angular'
import controller from './home.ctrl'
import template from './home.html'
import mainMenu from '../../shared/menu/menu.html'
import menu from './menu.html'
import './home.css'

export default angular.module('home', ['ui.router'])
  .config(function ($stateProvider) {
    'ngInject'
    $stateProvider.state('app.home', {
      url: '/home',
      resolve: {
        user: (Auth) => {
          'ngInject'
          return Auth.getDetails()
        }
      },
      views: {
        content: {
          template,
          controller,
          controllerAs: 'j'
        },
        menu: {
          template: mainMenu + menu
        }
      }
    })
  })
